import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import {
  Account,
  Attachment,
  Post,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { openConsent, openShare } from '../../../helpers';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { getImagePath } from '../../utils/getImagePath';
import { isBlacklisted } from 'src/app/utils/blacklist';
import { Router } from '@angular/router';

@Component({
  selector: 'app-desktop-fullscreen',
  templateUrl: './desktop-fullscreen.component.html',
  styleUrls: ['./desktop-fullscreen.component.scss'],
})
export class DesktopFullscreenComponent implements OnInit {
  @ViewChild('media') media: ElementRef;
  @ViewChild('postContent') postContent: ElementRef;

  attachments: Attachment[];
  post: Post;
  closeIcon = faTimes;
  index;
  height;
  contentHeight;

  constructor(
    navParams: NavParams,
    private router: Router,
    private modalCtrl: ModalController
  ) {
    this.index = navParams.get('index');
    this.post = navParams.get('post');
    this.attachments = this.getAttachments();
  }

  ngOnInit() {
    const wait = setInterval(() => {
      const element = document.querySelector('app-desktop-fullscreen');
      if (element) {
        this.contentHeight = element.clientHeight - 180 + 'px';
        clearInterval(wait);
      }
    }, 100);

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.modalCtrl.dismiss();
      }
    });
  }

  getAttachments = () => {
    if (!this.post.cover) return this.post.attachments;
    return [this.post.cover.image, ...this.post.attachments];
  };

  openSource(post: Post) {
    this.modalCtrl.dismiss().then(() => {
      if (!isBlacklisted(post.sourceURL)) {
        openConsent(post.sourceURL, undefined, this.modalCtrl);
      } else {
        openConsent(post.sourceURL, post.source.platform, this.modalCtrl);
      }
    });
  }

  goToStage({ handle }: Account) {
    this.modalCtrl.dismiss();
    this.router.navigate([`/${handle}`]);
  }

  openShare = (post) => {
    this.modalCtrl.dismiss().then(() => openShare(post, this.modalCtrl));
  };

  openConsent(url, platform) {
    this.modalCtrl
      .dismiss()
      .then(() => openConsent(url, platform, this.modalCtrl));
  }

  isDesktop() {
    return window.innerWidth >= 992;
  }

  getImageURL(fileName) {
    return getImagePath() + fileName;
  }

  handlePostToggle(event) {
    this.post = event.post;
    this.index = 0;
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
